
























































































import { formatCurrency } from "@/lib/utility/currency-helper";
import { Component, Prop, Vue } from "vue-property-decorator";
import { ExtendedLineItem, ObjectWithLineItemType } from "../repair-estimate/LineItemsForm.vue";
import InvoiceFormLinesTableRow from "./InvoiceFormLinesTableRow.vue";
import { PartnerModule } from "@/store/modules/partner";

@Component({
  components: {
    InvoiceFormLinesTableRow
  },
  filters: {}
})
export default class LineItemsTable extends Vue {
  readonly formatCurrency = formatCurrency;

  @Prop()
  value!: ObjectWithLineItemType;

  @Prop({ default: false })
  showTotal!: boolean;

  @Prop({ default: false })
  showLink!: boolean;

  @Prop({ default: false })
  showDescription!: boolean;

  productHref(item: ExtendedLineItem) {
    if (!item.productId) {
      return;
    }

    return this.$router.resolve({
      name: "ProductDetailView",
      params: { partnerId: PartnerModule.partner.id, productId: item.productId }
    }).href;
  }
}
